import {inject} from "@angular/core";
import {CanActivateFn, Router} from "@angular/router";
import {AuthService} from "../services/auth.service";

/**
 * `mfaPendingGuard` — protects the `/mfa/challenge` + `/mfa/enroll`
 * routes.
 *
 * Grants access only when the admin holds a `pending_mfa` JWT (set by
 * `/auth/google` on the challenge/enroll branches). Redirects:
 *
 *   • authenticated admin (full JWT already)  → /dashboard
 *   • neither token                            → /login
 *
 * NEVER co-existing state: the login flow either lands you here with a
 * pending token, or on /dashboard with a full token. If both signals
 * were true (e.g. a stale pending token in sessionStorage), we prefer
 * `isAuthenticated` — the full token IS a valid session.
 */
export const mfaPendingGuard: CanActivateFn = (_route, _state) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (auth.isAuthenticated()) {
        return router.createUrlTree(["/dashboard"]);
    }
    if (auth.hasPendingMfa()) {
        return true;
    }
    return router.createUrlTree(["/login"]);
};
